import { DashboardAsyncActions } from 'store/actions/dashboard';
import { createReducerFromActions } from 'utils/store';
import { values } from 'lodash';

export default createReducerFromActions(...values(DashboardAsyncActions));
